import { useState } from "react";
import { Button, Modal, Checkbox } from "antd";

type DeleteWorkspaceModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  id: string;
  onConfirm: () => void;
  saveDontAskAgain: (dontAskAgain: boolean) => void;
};

export function DeleteWorkspaceModal({
  isOpen,
  onCancel,
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
  id,
  onConfirm,
  saveDontAskAgain,
}: DeleteWorkspaceModalProps) {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  const handleCancel = () => {
    onCancel();
  };

  const handleConfirm = () => {
    onConfirm();
    saveDontAskAgain(dontAskAgain);
    onCancel();
  };

  return (
    <Modal
      open={isOpen}
      footer={
        <div className="flex items-center justify-between">
          <Button
            data-testid="delete-workspace-cancel-button"
            onClick={handleCancel}
            className="bg-white text-[#2B4752] border-[#D9D9D9] hover:border-[#2B4752]!"
          >
            Cancel
          </Button>
          <Button
            data-testid="delete-workspace-confirm-button"
            onClick={handleConfirm}
            className="bg-[#8B2020] text-white hover:bg-[#6B1818]! hover:text-white! border-[#8B2020] hover:border-[#6B1818]!"
          >
            Delete
          </Button>
        </div>
      }
      closable={false}
      onCancel={handleCancel}
      centered
      title={
        <div className="text-lg font-bold text-[#2B4752]">
          Delete workspace?
        </div>
      }
      width={450}
    >
      <div data-testid="delete-workspace-modal" className="space-y-4 my-4">
        <p className="text-[#5F6368] text-base">
          Are you sure you want to delete this workspace?
          <br />
          You can&apos;t recover it later.
        </p>

        <Checkbox
          checked={dontAskAgain}
          onChange={(e) => setDontAskAgain(e.target.checked)}
          className="text-[#2B4752]"
        >
          Don&apos;t ask me again
        </Checkbox>
      </div>
    </Modal>
  );
}
